import { usePWAInstall } from "../hooks/usePWAInstall"
import "./pwa-install.css"

export function PWAInstallPrompt() {
  const { isInstallable, installPWA } = usePWAInstall()

  if (!isInstallable) return null

  return (
    <div className="pwa-install-prompt">
      <p>Install AIX for easier access</p>
      <button onClick={installPWA} className="pwa-install-button">
        Install App
      </button>
    </div>
  )
}
